import { useApi } from 'services';

export const useGetDocuments = (idOperation) => useApi(`v2/operation/${idOperation}/documents`, 'GET', {}, {})

export const useUpdateDocument = (idOperation, idDocument) => useApi(`v2/operation/${idOperation}/documents/${idDocument}`, 'PUT', {}, {})

export const useGetDealDocuments = (idOperation) => useApi(`/quote/list-documents/${idOperation}`, 'GET', {}, {}, true)
